<template>
  <v-layout column justify-center>
    <v-flex>
      <v-layout row>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
        <v-btn
          slot="activator"
          round
          @click="pickFile"
        >
          <v-icon>add_a_photo</v-icon>
        </v-btn>
        <span>{{ imageTooltip }}</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      </v-layout>
      
    </v-flex>
    
    <v-flex>
      <v-img
        v-if="hasImage"
        :ref="imgId"
        class="mb-2 mt-1"
        contain
        style="cursor: pointer"
        :src="imageProps.src"
        height="100"
      />
    </v-flex>

    <input
      type="file"
      style="display: none"
      :ref="loaderId"
      accept="image/*"
      cancelable="true"
      multiple="false"
      cancelBubble="true"
      @change="onImageFilePicked"
    />
  </v-layout>
</template>

<script>
import appConfig from "../../../config/app_config";

export default {
  name: "MapIconLoader",
  props: {
    imageProps: Object,
  },
  watch: {},
  data() {
    return {
      hasImage: false,
      image: new Image(),
      imageTooltip: "upload an image",
      imgId: '',
      loaderId: '',
    };
  },
  created() {},
  mounted() {
    if (this.imageProps.src !== undefined && this.imageProps.src !== "") {
      this.image.src = this.imageProps.src;
      this.hasImage = true;
    }

    if(this.imageProps.id !== undefined) {
      this.loaderId = this.imageProps.id;
      this.imgId = this.loaderId + "_img";
    }
  },
  methods: {
    pickFile() {
      console.log("loaderId: ", this.loaderId);
      this.$refs[this.loaderId].click();
    },
    onImageFilePicked(a) {
      const maxSize = appConfig.maxSize.pictureSize;
      const files = a.target.files;

      if (files[0] !== undefined) {
        if (files[0].size > maxSize) {
          window.EventBus.fire(
            "activateSnackBar",
            "File can't be bigger than 1MB"
          );
          return;
        }

        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("error", () => {});
        fr.addEventListener("load", () => {
          //clean first
          this.image.src = "";
          this.hasImage = false;

          //reload the image
          this.image.src = fr.result;
          this.hasImage = true;

          this.$emit("uploadImage", this.image.src);
        });
      } else {
        // window.EventBus.fire("activateSnackBar", "File is not available");
        // this.image.src = "";
        // this.hasImage = false;
        // this.$emit("uploadImage", this.image.src);
      }
    },
  },
};
</script>

<style scope>
.v-btn-image-loader {
  margin-left: -7em !important;
  margin-top: 3em !important;
  min-width: 1em;
}

.not_show_content {
  display: block;
}
.show_content {
  display: block;
}
#fileInput {
  display: none;
}
</style>
